import { clsx } from 'clsx';
import { MouseEventHandler, ReactNode } from 'react';
import { useCollapse } from 'react-collapsed';

import { MyNumber } from '@/api/types';
import { RegionBadge } from '@/components/shared/RegionBadge/RegionBadge.tsx';
import { StatusBadge } from '@/components/shared/StatusBadge/StatusBadge.tsx';

import { ArrowDownIcon } from '../../icons/main-block';
import cn from './styles.module.scss';

interface INumberBlockProps {
    isNumberInTitle?: boolean;
    title?: string;
    isTariffTitle?: boolean;
    description?: string | ReactNode;
    region?: string;
    operator?: string;
    rightContent?: ReactNode;
    isExpandable?: boolean;
    isArrowShown?: boolean;
    children?: ReactNode;
    containerClassName?: string;
    headBlockClassName?: string;
    numberInfoClassName?: string;
    status?: MyNumber['status'];
    onClick?: VoidFunction;
}

export const Collapsible = ({
    isNumberInTitle,
    title,
    isTariffTitle = false,
    description,
    operator,
    region,
    rightContent,
    isExpandable = true,
    isArrowShown = true,
    children,
    containerClassName,
    headBlockClassName,
    numberInfoClassName,
    status,
    onClick,
}: INumberBlockProps) => {
    const { getToggleProps, getCollapseProps, isExpanded } = useCollapse();

    const toggleProps = getToggleProps();

    const handleClick: MouseEventHandler = e => {
        if (isExpandable) {
            toggleProps.onClick(e);
        }

        if (onClick) {
            onClick();
        }
    };

    return (
        <div className={clsx(cn.numBlockContainer, containerClassName)}>
            <div
                className={clsx(cn.numBlockHead, headBlockClassName)}
                {...(isExpandable ? toggleProps : {})}
                onClick={handleClick}
            >
                {operator && (
                    <div className={cn.imgWrapper}>
                        <img src={`/images/icons/operators/${operator}.svg`} alt="" />
                    </div>
                )}
                <div className={clsx(cn.numberInfo, numberInfoClassName)}>
                    <div className={clsx(cn.number, !isNumberInTitle && cn.defFont)}>
                        <span className={clsx(isTariffTitle && cn.tariffTitle)}>{title}</span>
                        {isArrowShown && (
                            <span className={clsx(cn.arrowIcon, isExpanded && cn.active)}>
                                {ArrowDownIcon}
                            </span>
                        )}
                    </div>
                    {description && <div className={cn.tariffs}>{description}</div>}
                </div>
                {status && <StatusBadge status={status} />}
                {region && <RegionBadge region={region} />}
                {rightContent && <div className={cn.rightContent}>{rightContent}</div>}
            </div>
            {children && (
                <div {...getCollapseProps()} className={cn.collapseContainer}>
                    <div className={cn.contentContainer}>{children}</div>
                </div>
            )}
        </div>
    );
};
